import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import axios from "axios";
import routes from "../../../app/routes";
import Loader from "../../ui/Loader";
import { getWindowDimension } from "../../../utils/getWindowDimension";

export default function Billing() {
  let [values, setValues] = useState([]);
  let [loader, setLoader] = useState(true);

  const { width, height } = getWindowDimension();

  const data = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "Year to Date Earnings",
        data: values,
        fill: true,
        backgroundColor: "rgba(33, 150, 83, 0.75)",
        borderColor: "rgba(33, 150, 83, 1)",
      },
    ],
  };
  if (width < 375) {
    data.labels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  }

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: (tooltipItem) => "",
          label: (tooltipItem, data) =>
            tooltipItem.label.replace(",", " ") +
            ": $" +
            tooltipItem.formattedValue,
        },
      },
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };

  useEffect(() => {
    axios.post(routes.api.coaches.billing).then((resp) => {
      let dataValues = Object.values(resp.data);
      setValues(dataValues);
      setLoader(false);
    });
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-md-8">
          <h2 className="font-w-600">Year to Date Earnings</h2>
        </div>
        <div className="col-md-4 nowrap">
          <h2 className="text-right">{`Total: $${values.reduce(
            (a, b) => a + b,
            0
          )}`}</h2>
        </div>
      </div>
      <hr />
      <Loader state={loader} />
      {!loader && Math.max(...values) == 0 && (
        <div className="empty-block">
          Your monthly paid amounts will be displayed here.
        </div>
      )}
      {!loader && Math.max(...values) > 0 && (
        <div className="coach-dashboard-wrapper-billing">
          <Line data={data} options={options} />
        </div>
      )}
    </>
  );
}
